import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Eye, ShoppingCart, Clock, User } from "lucide-react";
import { getWatchlistCount, getNotifications } from "@/lib/watchlistStore";
import { useAuth } from "@/contexts/AuthContext";
import { getUnseenAlertCount } from "@/lib/cloudServices";

const links = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/watchlist", icon: Eye, label: "Watchlist" },
  { to: "/basket", icon: ShoppingCart, label: "Basket" },
  { to: "/history", icon: Clock, label: "History" },
  { to: "/profile", icon: User, label: "Profile" },
];

export default function BottomNav() {
  const location = useLocation();
  const [watchCount, setWatchCount] = useState(0);
  const [notifCount, setNotifCount] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    setWatchCount(getWatchlistCount());
    setNotifCount(getNotifications().length);

    if (user) {
      getUnseenAlertCount(user.id).then((c) => {
        if (c > 0) setNotifCount(c);
      });
    }
  }, [location.pathname, user]);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-border/50 bg-background/95 backdrop-blur-md safe-area-bottom">
      <div className="flex items-stretch justify-around max-w-lg mx-auto h-[56px]">
        {links.map((link) => {
          const isActive = location.pathname === link.to;
          const showBadge = link.to === "/watchlist" && (watchCount > 0 || notifCount > 0);

          return (
            <NavLink
              key={link.to}
              to={link.to}
              className={`flex flex-col items-center justify-center gap-0.5 min-w-[72px] min-h-[44px] relative transition-colors ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground/90 active:text-foreground"
              }`}
            >
              {isActive && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-[2px] rounded-full bg-primary" />}
              <link.icon className="w-[18px] h-[18px]" strokeWidth={isActive ? 2.2 : 1.5} />
              <span className={`text-[10px] font-body ${isActive ? "font-medium" : ""}`}>{link.label}</span>
              {showBadge && notifCount > 0 && (
                <span className="absolute top-1 right-2 w-3.5 h-3.5 rounded-full bg-score-high text-primary-foreground text-[8px] font-bold flex items-center justify-center animate-pulse">
                  {notifCount}
                </span>
              )}
              {showBadge && notifCount === 0 && (
                <span className="absolute top-2 right-3 w-1.5 h-1.5 rounded-full bg-primary" />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
